export default __webpack_public_path__ + "static/media/942.21aca625.png";